const textEllipsis = (text, maxLength) => {
  const ellipsis = '...';
  return text.length > maxLength ? text.slice(0, maxLength - ellipsis.length) + ellipsis : text;
};

export { textEllipsis };
